import type { SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyleFunc<boolean | undefined> = (disabledClear) => ({
  width: disabledClear ? '100%' : 'initial',
});
